import { DBOperationEnum, UserSecondaryApiTypeRecord } from '@tassat/fred-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import { getUserApiTypes, getUsers } from './common';

const getIncludeDeleted = (_state: AdminState | ClientState, includeDeleted: boolean) => includeDeleted;
const getUserId = (_state: AdminState | ClientState, _includeDeleted: boolean, userId: string) => userId;
const getFirmId = (_state: AdminState | ClientState, _includeDeleted: boolean, firmId: string) => firmId;

export const getActiveApiTypes = createSelector(
    [getUserApiTypes],
    (userApiTypes): {
        [userId: string]: UserSecondaryApiTypeRecord[];
    } => {
        return Object.keys(userApiTypes)
            .reduce((acc, userId) => {
                const userApiTypesArray = Object.values(userApiTypes[userId]);
                const activeUserApiTypes = userApiTypesArray
                    .filter((userApi) => userApi.DbOperation !== DBOperationEnum.DELETE_OP.charCodeAt(0));

                acc[userId] = activeUserApiTypes;

                return acc;
            }, {});
    }
);

export const getApiTypesByUserId = createSelector(
    [ getUserApiTypes, getIncludeDeleted, getUserId ],
    (userApiTypes, includeDeleted, userId): Array<UserSecondaryApiTypeRecord> => {
        let result: Array<UserSecondaryApiTypeRecord> = [];
        if (userApiTypes[userId]) {
            result = Object.values(userApiTypes[userId]);
        }

        if (!includeDeleted) {
            return result.filter((api) => api.DbOperation !== DBOperationEnum.DELETE_OP.charCodeAt(0));
        }

        return result;
    }
);

export const getAllUserApiTypesArray = createSelector(
    [ getUserApiTypes, getIncludeDeleted ],
    (userApiTypes, includeDeleted): Array<UserSecondaryApiTypeRecord> => {
        const result: Array<UserSecondaryApiTypeRecord> = [];
        Object.keys(userApiTypes)
            .forEach((userId) => {
                result.push(...Object.values(userApiTypes[userId]));
            });

        if (!includeDeleted) {
            return result.filter((api) => api.DbOperation !== DBOperationEnum.DELETE_OP.charCodeAt(0));
        }

        return result;
    }
);

export const getAllUserApiTypesByFirmIdArray = createSelector(
    [ getUserApiTypes, getIncludeDeleted, getFirmId, getUsers ],
    (userApiTypes, includeDeleted, firmId, allUsers): Array<UserSecondaryApiTypeRecord> => {
        const firmUsers = Object.values(allUsers)
            .filter(user => !user.IsDeleted && !user.IsAdmin && user.FirmId === firmId);

        const usersApiTypeByFirmId = Object.keys(userApiTypes)
            .reduce((acc, key) => {
                const isUserMapToSecondaryApi = firmUsers.some((user) => user.UserId === key);

                if (isUserMapToSecondaryApi) {
                    acc.push(...Object.values(userApiTypes[key]));
                }

                return acc;
            }, [] as Array<UserSecondaryApiTypeRecord>);

        if (!includeDeleted) {
            return usersApiTypeByFirmId.filter((api) => api.DbOperation !== DBOperationEnum.DELETE_OP.charCodeAt(0));
        }

        return usersApiTypeByFirmId;
    }
);